import { Box, Grid2 as Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { SelectBoxOption } from "../../../interfaces";
import { useAppDispatch } from "../../../redux";
import {
  paginationInterface,
  PositionError,
  updatePaginationConfig,
  updatePaginationOverall,
} from "../../../redux/slices/documentTemplate";
import {
  HorizontalPosition,
  paginationFormatOptions,
  VerticalPosition,
} from "../../../utils";
import { AntSwitch } from "../../antSwitch";
import { HighlightSelectBox } from "../../highLightSelectBox";
import { CollapsableHeader } from "../header";

export const PageNumber: React.FC<{
  title: string;
  showSwitch?: boolean;
  switchStatus?: boolean;
  paginationDetails: paginationInterface;
  error: PositionError;
}> = (props) => {
  const { paginationDetails, error } = props;

  const dispatch = useAppDispatch();

  const isMatch = useMediaQuery("(max-width:1530px)");

  useEffect(() => {
    if (paginationDetails.showPageTextOf) {
      dispatch(
        updatePaginationOverall({
          ...paginationDetails,
          showPageNumberOf: false,
          showPageNumber: false,
          format: paginationFormatOptions[0],
        })
      );
    }
    // eslint-disable-next-line
  }, [paginationDetails.showPageTextOf]);

  useEffect(() => {
    if (paginationDetails.showPageNumberOf) {
      dispatch(
        updatePaginationOverall({
          ...paginationDetails,
          showPageTextOf: false,
          showPageNumber: false,
          format: paginationFormatOptions[1],
        })
      );
    }
    // eslint-disable-next-line
  }, [paginationDetails.showPageNumberOf]);

  useEffect(() => {
    if (paginationDetails.showPageNumber) {
      dispatch(
        updatePaginationOverall({
          ...paginationDetails,
          showPageTextOf: false,
          showPageNumberOf: false,
          format: paginationFormatOptions[2],
        })
      );
    }
    // eslint-disable-next-line
  }, [paginationDetails.showPageNumber]);

  return (
    (<CollapsableHeader
        title={props.title}
        showIcon={true}
        isExpanded={true}
        showSwitch={props.showSwitch}
        switchStatus={props.switchStatus}
        onSwitchChanged={(isChecked: boolean) =>
          dispatch(updatePaginationConfig({ key: "isActive", value: isChecked }))
        }
      >
      <Box sx={{
        p: 2
      }}>
        <Grid container spacing={1}>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <Stack direction="row" spacing={1} sx={{
              alignItems: "center"
            }}>
              <AntSwitch
                checked={paginationDetails.showPageTextOf}
                onChange={(e, isChecked) =>
                  dispatch(
                    updatePaginationConfig({
                      key: "showPageTextOf",
                      value: isChecked,
                    })
                  )
                }
              />
              <Typography>1 of N</Typography>
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <Stack direction="row" spacing={1} sx={{
              alignItems: "center"
            }}>
              <AntSwitch
                checked={paginationDetails.showPageNumberOf}
                onChange={(e, isChecked) =>
                  dispatch(
                    updatePaginationConfig({
                      key: "showPageNumberOf",
                      value: isChecked,
                    })
                  )
                }
              />
              <Typography variant="body2">1/N</Typography>
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6
            }}>
            <Stack direction="row" spacing={1} sx={{
              alignItems: "center"
            }}>
              <AntSwitch
                checked={paginationDetails.showPageNumber}
                onChange={(e, isChecked) =>
                  dispatch(
                    updatePaginationConfig({
                      key: "showPageNumber",
                      value: isChecked,
                    })
                  )
                }
              />
              <Typography variant="body2">1</Typography>
            </Stack>
          </Grid>
          <Grid
            container
            columns={isMatch ? 12 : 13}
            sx={{
              columnGap: isMatch ? 0 : 1,
              justifyContent: "space-between"
            }}>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                xl: 6
              }}>
              <HighlightSelectBox
                options={HorizontalPosition}
                label={"Horizontal Position"}
                onChange={(position: SelectBoxOption) => {
                  dispatch(
                    updatePaginationConfig({
                      key: "xPosition",
                      value: position,
                    })
                  );
                }}
                value={paginationDetails.xPosition}
                error={error.xPositionError}
                helperText={
                  error.xPositionError
                    ? "Please select the page number horizontal position"
                    : ""
                }
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 12,
                xl: 6
              }}>
              <HighlightSelectBox
                options={VerticalPosition}
                label={"Vertical Position"}
                onChange={(position: SelectBoxOption) => {
                  dispatch(
                    updatePaginationConfig({
                      key: "yPosition",
                      value: position,
                    })
                  );
                }}
                value={paginationDetails.yPosition}
                error={error.yPositionError}
                helperText={
                  error.yPositionError
                    ? "Please select the page number vertical position"
                    : ""
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </CollapsableHeader>)
  );
};
